"use strict";
angular.module("manageSysXhsgRenewConfigModule", [])
    .controller("manageSysXhsgRenewConfigCtrl", ['$scope', 'trsHttpService', '$modalInstance', 'modalDialog', 'items', '$filter', 'trsspliceString', '$validation',
        function($scope, trsHttpService, $modalInstance, modalDialog, items, $filter, trsspliceString, $validation) {
            initStatus();
            initData();

            /**
             * [initStatus 初始化状态]
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    ENDTIME: '',
                };
                $scope.data = {
                    LINENAMES: '',
                    IDS: '',
                };
            }

            /**
             * [initData 初始化数据]
             * @return {[type]} [description]
             */
            function initData() {
                requestData();
            }

            /**
             * [requestData description]
             * @return {[type]} [description]
             */
            function requestData() {
                var params = {
                    serviceid: 'mlf_xinhuashe',
                    methodname: 'querryRenewXHSLineAuthors',
                    ids: trsspliceString.spliceString(items, 'XHSLINEAUTHORID', ',')
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    $scope.data.LINENAMES = data.LINENAMES.replace(/\,/g, ';');
                    $scope.data.IDS = data.IDS;
                });
            }

            /**
             * [confirm 确定]
             * @return {[type]} [description]
             */
            $scope.confirm = function() {
                $validation.validate($scope.renewConfig).success(function() {
                    save();
                }).error(function() {
                    modalDialog.alertType('请选择授权结束时间', '', 'info', false);
                });
            };

            /**
             * [save 保存续费时间]
             * @return {[type]} [description]
             */
            function save() {
                var params = {
                    serviceid: 'mlf_xinhuashe',
                    methodname: 'renewXHSLineAuthors',
                    ids: $scope.data.IDS,
                    endTime: $filter('date')($scope.status.ENDTIME, 'yyyy-MM-dd'),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    if (data.ISSUCCESS == 'true') {
                        modalDialog.alertType(data.DETAIL, '', 'success', false, function() {
                        	$modalInstance.close('success');
                        });
                    } else {
                        modalDialog.alertType(data.DETAIL, '', 'error', false, function() {});
                    }
                });
            }

            /**
             * [cancel 关闭]
             * @return {[type]} [description]
             */
            $scope.cancel = function() {
                $modalInstance.dismiss();
            };
        }
    ]);